import * as SpecialOfferActions from './special-offer.actions';
import {SpecialOfferModel} from '../special-offer.model';

export interface State {
  actualOffer: SpecialOfferModel;
}

export const initialState: State = {
  actualOffer: null
};

export function specialOfferReducer(state = initialState, action: SpecialOfferActions.SpecialOfferActions) {
  switch(action.type) {
    case SpecialOfferActions.SAVE_SPECIAL_OFFER_ACTUAL:
      return {
        ...state,
        actualOffer: action.payload
      };
    case SpecialOfferActions.CLOSE_SPECIAL_OFFER:
      return {
        ...state
      };
  }

  return state;
}
